import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from 'src/app/services/shared.service';

export interface ChatMessagePart {
  text: string;
}

export interface ChatMessage {
  role: string;
  parts: ChatMessagePart[];
	loading?: boolean;
}

@Component({
    selector: 'app-conv-vertexai-chat',
    templateUrl: './conv-vertexai-chat.component.html',
    styleUrl: './conv-vertexai-chat.component.scss',
    standalone: false
})
export class ConvVertexaiChatComponent {
  @ViewChild('scrollRef') scrollRef: any;
  @ViewChild('successModal') successModal!: TemplateRef<any>;
  @ViewChild('resetChatModal') resetChatModal!: TemplateRef<any>;
  @ViewChild('reportModal') reportModal!: TemplateRef<any>;
  @ViewChild('reGenerateReportModal') reGenerateReportModal!: TemplateRef<any>;

  @Input() url_service!: any;

  pchat = 'assets/images/logo/logo-only.png';
	chat_lang = 'en'
  loading = false;
  main_loading = false;

  formData!: UntypedFormGroup;
  chatMessagesData: ChatMessage[] = [];
  submitted = false;
  isProfile: string = this.pchat;
  isreplyMessage = false;

  deleteModalRef: any;
  reportModalRef: any;
  reGenerateReportModalRef: any;

  spinner = false;
  success = false;
  message = '';
  successMessage = '';

	templateMode: any = null;	

  constructor(public formBuilder: UntypedFormBuilder, private sharedService: SharedService, private modalService: NgbModal) { }
  
  ngOnInit(): void {
    this.main_loading = true;
    this.formData = this.formBuilder.group({
      message: ['', [Validators.required]],
    });

    const chatInput = document.getElementById('chat-input') as HTMLTextAreaElement;

    chatInput.addEventListener('keydown', (event) => {
      if (event.ctrlKey && event.key === 'Enter') {
        event.preventDefault();
        const currentPosition = chatInput.selectionStart;
        chatInput.value = chatInput.value.substring(0, currentPosition) + '\n' + chatInput.value.substring(currentPosition);
        chatInput.selectionStart = currentPosition + 1;
        chatInput.selectionEnd = currentPosition + 1;
      }
    });

    chatInput.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && !event.ctrlKey) { 
        event.preventDefault();
        this.messageSave(); 
      }
    });

    chatInput.addEventListener('keydown', (event) => {
      if (event.code === 'ShiftRight' && event.ctrlKey && event.location === 2) {
        event.preventDefault();
        this.chat_lang = 'he';
      } else if (event.code === 'ShiftLeft' && event.ctrlKey && event.location === 1) {
        event.preventDefault();
        this.chat_lang = 'en';
      }
    });

    this.sharedService.initialChatVertexAI(this.url_service.chatVertexAI).subscribe({
      next: (data: any) => {
        this.chatMessagesData = data.conversationHistory;

        this.onListScroll();
        this.main_loading = false;
        this.submitted = false;
      },
      error: () => {
        this.main_loading = false;
        this.submitted = false;
      }
    });
  }

  ngAfterViewInit(): void {
    this.onListScroll();
  }

  onListScroll() {
		setTimeout(() => {
			this.scrollRef.SimpleBar.getScrollElement().scrollTop = this.scrollRef.SimpleBar.getScrollElement().scrollHeight;
		}, 500);
	}

	get form() {
    return this.formData.controls;
  }

	changeChatLang() {
		switch (this.chat_lang) {
			case 'he':
				this.chat_lang = 'en';
				break;
			case 'en':
				this.chat_lang = 'he';
				break;
			default:
				this.chat_lang = 'en';
				break;
		}
	}

	messageSave() {
		this.loading = true;
		this.submitted = true;

		if (!this.formData.valid) {
			this.loading = false;
			return;
		}

		if (this.form['message'].value === '') {
			this.loading = false;
			return;
		}

		const message = {
			role: 'user',
			parts: [{ text: this.form['message'].value}]
		};

    const question = this.form['message'].value;

		this.chatMessagesData.push(message);
		this.onListScroll();

		this.formData = this.formBuilder.group({
			message: null,
		});

		this.chatMessagesData.push({
			role: 'model',
      parts: [], // Initially empty
      loading: true 
		});

		this.sharedService.chatWithVertexAI(this.url_service.chatVertexAI, { message: question }).subscribe({
			next: (data: any) => {
				this.chatMessagesData[this.chatMessagesData.length-1].parts.push({ text: data.answer });
        this.chatMessagesData[this.chatMessagesData.length-1].loading = false;

				this.onListScroll();
				this.loading = false;
				this.submitted = false;
			},
			error: () => {
				this.loading = false;
				this.submitted = false;
			}
		});
	}

	openResetChatModal() {
		this.deleteModalRef = this.modalService.open(this.resetChatModal, { size: 'l', backdrop: 'static', keyboard : false });
	}

	closeReportModal() {
		if (document.documentElement.getAttribute('data-bs-theme') !== this.templateMode) {
			document.documentElement.setAttribute('data-bs-theme', this.templateMode);
		}

		this.reportModalRef.close();
	}

	resetChat() {
		this.loading = true;
		this.submitted = true;
		this.spinner = true;

		this.sharedService.endChatWithVertexAI(this.url_service.chatVertexAI).subscribe({
			next: (data) => {
				this.chatMessagesData = data.conversationHistory;

				this.onListScroll();
				this.submitted = false;
				this.spinner = false;
				this.success = true;
				this.loading = false;
				this.successMessage = 'Chat has been reset successfully.';
				this.deleteModalRef.close();
				this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
			},
			error: (err) => {
				this.submitted = false;
				this.spinner = false;
				this.success = false;
				this.loading = false;
				this.successMessage = 'Chat can not be reset!';
				this.message = err;

				this.deleteModalRef.close();
				this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
			}
		});
	}
}
